import React from "react";

const ComponentIdentifier = ({ link_name = "link", component_name = "component" }) => {
    return <h6 className="fw-bold text-muted my-0">{link_name}  {component_name}</h6>
}

export default ComponentIdentifier